
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import { translate, statusColor } from "@/core/services/HelpersFun";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { storeToRefs } from "pinia";

import { AllBots } from "@/store/pinia/AllBots";

export default defineComponent({
  name: "kt-otp-management-table",
  components: {},
  props: {
    widgetClasses: String,
  },
  setup() {
    const loading = ref(true);
    const list = ref();
    const pagination = ref();
    const mobile = ref();

    const AllBotsHolder = AllBots();
    const { botList } = storeToRefs(AllBotsHolder);
    const { fetchBotList } = AllBotsHolder;

    onMounted(async () => {
      await fetchBotList();

      list.value = botList.value?.filter((bot) =>
        bot.platforms.some((platform) => platform.platform === "instagram")
      );
      console.log(list.value);
      setCurrentPageBreadcrumbs(translate("اینستاگرام"), []);
    });

    return {
      loading,
      pagination,
      translate,
      statusColor,
      mobile,
      list,
    };
  },
});
